import { render } from "./PlayButton.vue?vue&type=template&id=2b60f47f&scoped=true"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"

import "./PlayButton.vue?vue&type=style&index=0&id=2b60f47f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b60f47f"]])

export default __exports__